<template>
    <a v-if="externalUrl"
       :href="registrationCategory.external_url"
       class="btn btn-block btn-xs align-bottom"
       :class="btnData.className"
       :disabled="btnData.disabled"
       target="_blank"
    >
        <slot name="btn-text">{{ btnData.text }}</slot>
    </a>
    <button
        v-else
        class="btn btn-block btn-xs align-bottom ticket-list-enter-btn"
        :class="btnData.className"
        :disabled="btnData.disabled"
        :onclick="widgetString"
    >
        <slot name="btn-text"><span class="ticket-list-enter-btn-text">{{ btnData.text }}</span></slot>
    </button>
</template>

<script>
export default {
    name: "EnterBtn",
    props: {
        registrationCategory: {
            type: Object,
            required: true,
        },
    },
    computed: {
        btnData() {
            switch (this.registrationCategory.human_status) {
                case 'human_status_closed':
                    return {
                        className: 'btn-danger',
                        disabled: true,
                        text: 'Closed',
                    }
                case 'human_status_full':
                    return {
                        className: 'btn-danger',
                        disabled: true,
                        text: 'Full',
                    }
                case 'human_status_inactive':
                    if (this.registrationCategory.active_date === null) {
                        return {
                            className: 'btn-danger',
                            disabled: true,
                            text: 'Inactive',
                        }
                    }

                    moment.relativeTimeThreshold('h', 36); //least number of hour to be considered a day
                    let opensIn = moment(this.registrationCategory.active_date).fromNow();

                    return {
                        className: 'btn-warning',
                        disabled: true,
                        text: `Opens ${opensIn}`,
                    }
                case 'human_status_open':
                    return {
                        className: 'btn-success',
                        disabled: false,
                        text: 'Enter Now',
                    }
                case 'human_status_waiting_list':
                    return {
                        className: 'btn-warning',
                        disabled: false,
                        text: 'Join Waiting List',
                    }
            }
        },
        externalUrl() {
            return this.registrationCategory.external_url ? true : false;
        },
        /**
         * Gets any additional URL query params that have been passed in on the URL
         *
         * @returns {string}
         */
        searchParams() {
            return new URLSearchParams(window.location.search).toString();
        },
        widgetString() {
            const queryString = new URLSearchParams({
                checkout: 'external',
                rId: this.registrationCategory.id,
                container: 'internal',
            }).toString();

            return `eventracOpenEntryForm(${this.registrationCategory.occasion_id}, '${queryString.toString()}')`;
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/RegistrationCategories/Tickets/Utility/EnterBtn.vue